<template>

	<div class="container">
		<h1 class="has-text-centered">Portfolios</h1>
		<div class="level">
			<div class="level-left">

			</div>
			<div class="level-right">
				<div class="level-item">
					<b-button icon-left="calculator" :disabled="checkedRows.length != 2" class="is-primary" @click="$router.push({ name: 'ComparePortfolios', params: { idOne: checkedRows[0].Id, idTwo: checkedRows[1].Id } })">Compare two portfolios</b-button>
				</div>
				<div class="level-item">
					<b-button icon-left="folder-plus" class="is-primary" @click="savePortfolio">Create new portfolio</b-button>
				</div>
			</div>
		</div>
		<b-table :data="portfolios"
				 hoverable
				 :loading="isLoading"
				 :checked-rows.sync="checkedRows"
				 default-sort="Name"
				 default-sort-direction="asc"
				 checkable
				 mobile-cards>
			<b-table-column field="Name" label="Name" v-slot="props" sortable>
				<a @click="$router.push('/portfolio/manage/' + props.row.Id)">{{ props.row.Name }}</a>
			</b-table-column>
			<b-table-column field="Description" label="Description" v-slot="props" sortable>
				{{ props.row.Description }}
			</b-table-column>
			<b-table-column field="CarbonOutput" width="220" label="Aggregate Annual C02 emissions (tonnes)" v-slot="props" numeric sortable>
				{{ $math.format($math.round(props.row.CarbonOutput, 3)) }}
			</b-table-column>
			<b-table-column field="LastModified" width="180" label="Last Modified" v-slot="props" sortable>
				{{ props.row.LastModified | moment("DD MMM, YYYY") }}
			</b-table-column>
			<b-table-column label="Actions" width="180" v-slot="props" sortable>
				<a @click="$router.push('/portfolio/manage/' + props.row.Id)">Manage</a> | <a @click="deletePortfolio(props.row.Id)">Delete</a>
			</b-table-column>
			<b-table-column label="Report" v-slot="props" sortable>
				<span><a @click="viewReport(props.row)">View</a></span>
			</b-table-column>
			<b-table-column label="Certificate" v-slot="props" sortable>
				<portfolio-certificate @complete="setDownloading(props.row, false)" :Portfolio="props.row"></portfolio-certificate>
			</b-table-column>
		</b-table>
	</div>

</template>

<script>
	import portfolioCertificate from "@/components/certificates/portfolioCertificate.vue";
	import SavePortfolio from '@/components/modals/savePortfolio.vue';
	export default {
		components: {
			'portfolio-certificate': portfolioCertificate
		},
		data() {
			return {
				isLoading: true,
				portfolios: [],
				checkedRows: []
			}
		},
		async created() {
			await this.getPortfolios();
		},
		methods: {
			getPortfolios() {
				this.$http.get("api/portfolio")
					.then(resp => {
						this.portfolios = resp.data;
						this.isLoading = false;
					});
			},
			download(row) {
				this.setDownloading(row, true);
			},
			setDownloading(row, downloading) {
				this.$set(row, 'downloading', downloading);
			},
			viewReport(row) {
				this.$router.push({ name: "PortfolioReport", params: { PortfolioId: row.Id } });
			},
			deletePortfolio(id) {
				this.$buefy.dialog.confirm({
					message: this.ConfirmDelete || 'Are you sure you want to delete this portfolio?',
					onConfirm: async () => {
						var response = await this.$http.delete("api/portfolio/" + id);
						if (response.data == true) {
							const i = this.portfolios.map(x => x.Id).indexOf(id);
							this.portfolios.splice(i, 1);
							this.$buefy.toast.open({
								message: "Successfully deleted portfolio",
								type: 'is-success',
							});
						}
						else {
							this.$buefy.toast.open({
								message: "Failed to delete portfolio",
								type: 'is-danger'
							});
						}
					}
				});
			},
			savePortfolio() {
				this.$buefy.modal.open({
					parent: this,
					component: SavePortfolio,
					hasModalCard: true,
					events: {
						refreshPortfolio: async (portfolio) => {
							this.getPortfolios();
						}
					}
				})
			}
		}
	}
</script>
